/* eslint-disable @typescript-eslint/no-explicit-any */
import { 
    fetchCloudPerformance,
    setTimeRange as setCloudTimeRange,
    setInterval as setCloudInterval,
 } from "@redux/slices/kontrolEdge/connectionSlice";
import { 
    fetchPortPerformance,
    setTimeRange as setPortTimeRange,
    setInterval as setPortInterval,
 } from "@redux/slices/kontrolEdge/portSlice";
import { RootState } from "@redux/store/store";


export type BandwidthService = "port" | "cloud" ;

export type Duration = `${number}${"s" | "m" | "h" | "d"}`;

export interface BandwidthSliceShape {
  timeRange: Duration | null;   // allow null until initialized
  interval: Duration | null;
  performanceData: any | null;
  performanceLoading: boolean;
  performanceError: string | null;
  initialized?: boolean;        // optional, if you added it
}

export interface FetchArgsCommon {
  api: any;
  tenantId: number;
  timeRange: string;
  interval: string;
}

export interface ServiceAdapter {
  // how to read this service state from the store
  select: (s: RootState) => BandwidthSliceShape;

  // how to fetch for this service
  fetchThunk: (args: FetchArgsCommon & { id: string }) => any;

  // how to update controls in this service
  setTimeRange: (v: Duration) => any;
  setInterval: (v: Duration) => any;

  // optional helper to set both at once (recommended). If not present, chart will fallback to individual sets.
  setTimeControls?: (p: { timeRange: Duration; interval: Duration }) => any;

  // label/id key for the fetch (only used in comments/error messages)
  idPropName: "portId" | "connectionId";
}

export const PortAdapter: ServiceAdapter = {
  select: (s) => s.port as BandwidthSliceShape,
  fetchThunk: ({ api, tenantId, timeRange, interval, id }) =>
    fetchPortPerformance({ api, portId: id, timeRange, interval, tenantId }),
  setTimeRange: setPortTimeRange,
  setInterval: setPortInterval,
  idPropName: "portId",
};

export const CloudAdapter: ServiceAdapter = {
  select: (s) => s.connection as BandwidthSliceShape,
  fetchThunk: ({ api, tenantId, timeRange, interval, id }) =>
    fetchCloudPerformance({ api, connectionId: id, timeRange, interval, tenantId }),
  setTimeRange: setCloudTimeRange,
  setInterval: setCloudInterval,
  idPropName: "connectionId",
};

export const SERVICE_ADAPTERS: Record<BandwidthService, ServiceAdapter> = {
  port: PortAdapter,
  cloud: CloudAdapter,
};
